import axios from "axios";
import baseUrl from "../../config/api";

/// log in (sign in)
export const contactStart = () => ({
  type: "CONTACT_START",
});

export const contactSuccess = (user) => ({
  type: "CONTACT_SUCCESS",
  payload: user,
});

export const contactFailure = () => ({
  type: "CONTACT_FAILURE",
});

// sign in thunk
export const contactStartAsync = (
  data,
  setSubmitting,
  resetForm,
  initialValues
) => {
  return async (dispatch) => {
    dispatch(contactStart());
    try {
      const response = await axios.post(`${baseUrl}/trackAPI/forms`, data);
      dispatch(contactSuccess(response.data.message));
      setSubmitting(false);
      resetForm(initialValues);
    } catch (error) {
      dispatch(contactFailure());
      dispatch(
        addError(
          error.response?.data.error ||
            "Couldn't reach the server, please check your interent connection or try again later"
        )
      );
      setSubmitting(false);
    }
  };
};

// error actions
export const addError = (error) => ({
  type: "ADD_ERROR",
  payload: error,
});

export const removeError = (error) => ({
  type: "REMOVE_ERROR",
  payload: error,
});

export const clearErrors = () => ({
  type: "CLEAR_ERRORS",
});

// other actions are too simple to define here
